import React, {Component} from 'react';
import Datetime from 'react-datetime';

import MainMenu from '../../components/menu/MainMenu';
import { Card, Col, Row, Form, Button } from 'react-bootstrap';
import moment from 'moment';
import './react-datetime.css';
import SimpleModal from '../../components/modal/SimpleModal';
import LoadingModal from '../../components/modal/LoadingModal';
import { downloadSso250ReportByReportDate } from '../../resources/API';
import { Redirect } from 'react-router-dom';
class Sso250Report extends Component {

    constructor(props) {
        super();
        this.state = {
            reportDate : "",
            modal: {
                header: null,
                body: null,
                footer: null,
                show: false,
                variant: 'danger'
            },
            loading: {
                value: false,
                hide : () => {this.setState({loading : {...this.state.loading, value:false}})},
                show : () => {this.setState({loading : {...this.state.loading, value:true}})},
            }
        }
    }

    handleModalClose = () => {
        let modal = this.state.modal;
        this.setState({ modal: { ...modal, show: false } })
    }

    handleDownload = async (e) => {
        e.preventDefault();
        const {downloading, accessToken} = this.props;
        const {reportDate} = this.state;
        let downloadResponse;
        downloading.set(true);
        downloadResponse = await downloadSso250ReportByReportDate(reportDate, accessToken);
        downloading.set(false);
        if(downloadResponse.status !== 200){
            if(downloadResponse.status === 404){
                this.setState({
                    modal: {
                        header: "Report Not Found",
                        body: "The report does not exist. Please try again.",
                        footer: null,
                        show: true,
                        variant: 'scb'
                    }
                });
            }else {
                this.setState({
                    modal: {
                        header: "Error",
                        body: "Error occured while downloading report",
                        footer: null,
                        show: true,
                        variant: 'danger'
                    }
                });
            }
        }
    }

    handleChange = (e) => {
        const {name, value} = e.target;
        const temp = this.state;
        temp[name] = value;
        this.setState(temp)
    }

    render() {
        const {reportDate, modal, loading} = this.state;
        const {role, downloading} = this.props;
        const disabled = downloading.value || !reportDate;

        if (!role.includes("SSO")) {
            return <Redirect to='/unauthorized' />
        }

        const fromDate = moment().subtract(6, 'month');
        const toDate = moment().subtract(1, 'day');
        const valid = function( current ){   
            return  current.isSameOrAfter(fromDate, 'day') && current.isSameOrBefore(toDate, 'day');
        };
        
        return (
            <React.Fragment>
                <Card className="shadow mt-2 mx-auto mb-70px card-width-1280">
                    <Card.Body className="p-0 bg-grey">
                        <MainMenu mainMenu={"operationreports"} subMenu={"sso250Bytes"} role={role}/>
                        <Card className="shadow mt-4 mx-auto card-width-1200">
                            <Card.Header className="pt-3 pb-2 bg-white">
                                <Row>
                                    <Col sm={12} className="text-scb font-weight-bold">
                                    SSO Text File Format 250 Bytes Report
                                    </Col>
                                </Row>
                            </Card.Header>
                            <Card.Body>
                                <Form onSubmit={this.handleDownload}>
                                    <Row>
                                        <Col>
                                            <Row className="my-3">
                                                <Col sm={5} className="text-grey font-weight-bold medium text-right pt-2 required">Report Effective Date</Col>
                                                <Col sm={3}>
                                                    <Datetime
                                                        isValidDate = {valid}
                                                        onChange={(date) => {
                                                        const dateStr = moment.isMoment(date) ? date.format("YYYYMMDD") : date;
                                                        this.handleChange({ target: { name: 'reportDate', value: dateStr } })
                                                        }}
                                                        dateFormat="DD MMMM YYYY"
                                                        timeFormat={false}
                                                        inputProps={{ placeholder: 'Report effective date', required: true }}
                                                        value={moment(reportDate, "YYYYMMDD", true).isValid() ? moment(reportDate, "YYYYMMDD", true) : reportDate}
                                                    />
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                    <Row className="my-3">
                                        <Col sm={{offset: 5, span :2}}>
                                            <Button type="submit" block variant="scb" disabled={disabled}>Download</Button>
                                        </Col>
                                    </Row>
                                </Form>
                            </Card.Body>
                        </Card>
                    </Card.Body>
                </Card>
                <LoadingModal show={loading.value} />
                <SimpleModal
                    modal={modal}
                    onClose={this.handleModalClose}
                />
            </React.Fragment>
        );
      }
}
export default Sso250Report;